import { createBaseApi } from '../baseApi';

export const userApi = createBaseApi('userApi').injectEndpoints({
  endpoints: (builder) => ({
    // Add contact endpoint
    sendContactMessage: builder.mutation({
      query: (contactData) => ({
        url: 'email-service/send',
        method: 'POST',
        body: contactData
      })
    }),
  }),
});

export const { useSendContactMessageMutation } = userApi;
